module.exports = __webpack_public_path__ + "static/media/eventsIcons.dc6e3a7e.svg";